import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const ProductStartedEventSchema = order.fulfillmentService.versions.v1.schemas.PRODUCT_STARTED;

export type ProductStartedEventPayload = z.infer<typeof ProductStartedEventSchema>;
